import React            from 'react';

import DateRangeReport  from 'Manager/components/DateRangeReport';
import PayrollTable     from 'Manager/components/PayrollTable';

export default class Payroll extends DateRangeReport {
    getTitle() : (string|React.ReactNode) {
        const urlSearchParams = new URLSearchParams({
            csv    : '1',
            min_ts : this.state.min_ts,
            max_ts : this.state.max_ts
        });
        return (
            <React.Fragment>
                Payrolls from {this.state.min_ts} to {this.state.max_ts}
                <a key='download' href={`/api/manager/report/payroll?${urlSearchParams.toString()}`}><i className="fa fa-download"/></a>
            </React.Fragment>
        );
    }
    getTable() : React.ReactNode {
        const getTablePromiseArgs = ( orderby:string, limit:number, skip:number ) => {
            return [
                '/api/manager/report/payroll',
                'GET',
                undefined,
                {
                    min_ts   : this.state.min_ts,
                    max_ts   : this.state.max_ts,
                    orderby,
                    limit,
                    skip
                }
            ];
        }
        return <PayrollTable min_ts={this.state.min_ts} max_ts={this.state.max_ts} getTablePromiseArgs={getTablePromiseArgs}/>;
    }
}